var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"float":"right"},attrs:{"text":"","right":"","color":"primary"}},[_vm._v(" Confirm "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-check")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }